/** Poppins + fallbacks — matches prior inline `fontFamily` stack */
export const queueFont =
  "font-['Poppins','Montserrat','Segoe_UI','Inter',system-ui,-apple-system,BlinkMacSystemFont,'Helvetica_Neue',Arial,sans-serif]";
